import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig } from '@spartacus/core';
import { SupplementHashAnchorsModule } from '@spartacus/storefront';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { provideDefaultConfig } from '../../../core/config';
import { PipesModule, ReadMoreModule } from '../../../shared';
import { ParagraphComponent } from './paragraph.component';

@NgModule({
  imports: [CommonModule, NzIconModule, ReadMoreModule, PipesModule, SupplementHashAnchorsModule],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        CMSParagraphComponent: {
          component: ParagraphComponent,
        },
        CMSTabParagraphComponent: {
          component: ParagraphComponent,
        },
      },
    }),
  ],
  declarations: [ParagraphComponent],
  exports: [ParagraphComponent],
})
export class CmsParagraphModule {}
